var _clipPath, _clipPath2, _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeMiterlimit: 10
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.08047,0,0,1.08047,-16.8753,-60.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-46"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M415.3,381.13C415.3,381.13 412,367 414.46,354.45C416.92,341.9 422.8,350.28 429.46,341.94C436.12,333.6 432.8,317.76 440.3,311.09C447.8,304.42 458.65,305.25 461.15,292.74C463.65,280.23 465.32,270.23 470.32,271.9C475.32,273.57 466.15,288.57 466.15,297.75C466.15,306.93 471.15,312.75 467.82,321.93C464.49,331.11 450.31,327.76 450.31,338.6C450.31,349.44 456.15,360.28 451.14,367.79C446.13,375.3 432.8,376.96 431.14,381.13C429.48,385.3 425.3,392.8 421.14,392.8C416.98,392.8 415.3,381.13 415.3,381.13Z",
    style: {
      fill: "rgb(191,191,191)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.58,381.28C413.42,378.78 411.75,357.1 404.25,352.93C396.75,348.76 388.4,350.43 384.25,342.93C380.1,335.43 380.08,332.09 375.92,331.26C371.76,330.43 351.73,327.09 354.24,331.26C356.75,335.43 371.75,328.76 371.75,337.09C371.75,345.42 370.08,358.77 375.08,362.09C380.08,365.41 393.43,364.59 392.59,372.09C391.75,379.59 389.26,382.09 393.43,384.59C397.6,387.09 409.27,397.94 410.94,389.59L412.58,381.28Z",
    style: {
      fill: "rgb(191,191,191)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.86,399.66C421.86,399.66 417.98,387.53 428.66,365.19C439.34,342.85 447.11,325.86 451.97,317.12",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.12,401.61C413.12,401.61 411.67,395.78 406.81,379.76C401.95,363.74 396.13,359.36 387.87,354.02C379.61,348.68 379.13,339.94 377.68,337.51",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.52,392.87C433.52,392.87 434.52,384.13 442.26,381.7C450,379.27 457.31,380.24 458.77,374.9C460.23,369.56 460.22,364.22 463.62,361.3C467.02,358.38 471.39,356.93 471.88,358.39C472.37,359.85 467.02,360.82 467.02,365.67C467.02,370.52 474.3,382.67 463.62,387.53C452.94,392.39 444.2,388.01 440.32,391.41C436.44,394.81 434,397.24 434,397.24L433.52,392.87Z",
    style: {
      fill: "rgb(191,191,191)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.55,401.61C432.55,401.61 436,389 444.2,386.07C452.4,383.14 461.68,389.47 465.56,383.64C469.44,377.81 466.56,371.99 466.05,368.1",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,399.66L407.9,399.66C406.572,399.66 405.48,400.752 405.48,402.08L405.48,402.1C405.48,403.428 406.572,404.52 407.9,404.52L408.15,404.52L410.49,410.67C410.862,411.642 411.799,412.288 412.84,412.29L433.07,412.29C434.111,412.288 435.048,411.642 435.42,410.67L437.77,404.52L438,404.52C439.333,404.52 440.43,403.423 440.43,402.09C440.43,400.757 439.333,399.66 438,399.66Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.75,406.94C261.75,404.005 264.165,401.59 267.1,401.59C270.035,401.59 272.45,404.005 272.45,406.94C272.45,409.875 270.035,412.29 267.1,412.29C267.097,412.29 267.093,412.29 267.09,412.29C264.161,412.29 261.75,409.879 261.75,406.95C261.75,406.947 261.75,406.943 261.75,406.94Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.42,406.94C264.42,406.937 264.42,406.933 264.42,406.93C264.42,405.46 265.63,404.25 267.1,404.25C268.57,404.25 269.78,405.46 269.78,406.93C269.78,408.4 268.57,409.61 267.1,409.61C265.634,409.61 264.425,408.406 264.42,406.94Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.44,406.94C204.44,404.005 206.855,401.59 209.79,401.59C212.725,401.59 215.14,404.005 215.14,406.94C215.14,409.875 212.725,412.29 209.79,412.29C206.855,412.29 204.44,409.875 204.44,406.94Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.12,406.94C207.12,406.937 207.12,406.933 207.12,406.93C207.12,405.46 208.33,404.25 209.8,404.25C211.27,404.25 212.48,405.46 212.48,406.93C212.48,408.4 211.27,409.61 209.8,409.61C209.797,409.61 209.793,409.61 209.79,409.61C208.327,409.605 207.125,408.403 207.12,406.94Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.72,406.94C185.72,404.005 188.135,401.59 191.07,401.59C194.005,401.59 196.42,404.005 196.42,406.94C196.42,409.875 194.005,412.29 191.07,412.29C191.067,412.29 191.063,412.29 191.06,412.29C188.131,412.29 185.72,409.879 185.72,406.95C185.72,406.947 185.72,406.943 185.72,406.94Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.39,406.94C188.39,406.937 188.39,406.933 188.39,406.93C188.39,405.46 189.6,404.25 191.07,404.25C192.54,404.25 193.75,405.46 193.75,406.93C193.75,408.4 192.54,409.61 191.07,409.61C189.604,409.61 188.395,408.406 188.39,406.94Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,-7.65714e-16,7.65714e-16,-1,447.49,743.71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.09,342.89L229.4,342.89L229.4,400.79L218.12,400.79L218.12,342.89L218.09,342.89Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,-7.65714e-16,7.65714e-16,-1,447.49,760.73)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 215.07,
    y: 359.91,
    width: 17.34,
    height: 40.91,
    style: {
      fill: "rgb(38,50,56)",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,-7.65714e-16,7.65714e-16,-1,485.15,635.21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.33,302L249.81,302L249.81,333.14L235.3,333.14L235.3,302.05L235.33,302Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.92,302L270.58,302C276.025,301.996 280.503,297.515 280.503,292.07C280.503,291.987 280.502,291.903 280.5,291.82L279.14,236.51C279.005,231.157 274.564,226.828 269.21,226.83L222.43,226.83C217.548,226.827 213.352,230.425 212.61,235.25L204.11,290.56C204.033,291.06 203.995,291.564 203.995,292.07C203.995,297.516 208.474,301.998 213.92,302Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.44,344.91L257.29,361.28",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.23,358.8L262.47,361.65C263.232,362.169 263.689,363.034 263.689,363.956C263.689,364.701 263.39,365.416 262.86,365.94L262.56,366.22C261.554,367.206 259.948,367.276 258.86,366.38L255,363.17C254.369,362.654 254.002,361.88 254.002,361.064C254.002,360.357 254.278,359.677 254.77,359.17C255.68,358.232 257.143,358.076 258.23,358.8Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.67,347.74L269.82,347.74C274.697,347.74 278.71,343.727 278.71,338.85C278.71,333.973 274.697,329.96 269.82,329.96L177.67,329.96C172.793,329.96 168.78,333.973 168.78,338.85C168.78,343.727 172.793,347.74 177.67,347.74Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.84,337.77C169.521,333.276 173.455,329.939 178,330L225.8,330C230.372,329.921 234.335,333.286 235,337.81C235.045,338.175 235.068,338.542 235.068,338.91C235.068,343.792 231.052,347.809 226.17,347.81L177.67,347.81C177.669,347.81 177.668,347.81 177.667,347.81C172.784,347.81 168.767,343.792 168.767,338.91C168.767,338.529 168.791,338.148 168.84,337.77Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,404.05L272.48,404.05C272.475,401.393 270.287,399.21 267.63,399.21L188.84,399.21C186.185,399.21 184,401.395 184,404.05Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.7,404.05L228.55,404.05L228.55,399.21L204.55,399.21C201.893,399.21 199.705,401.393 199.7,404.05Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.57,292.78L187.19,303.29C187.19,303.29 164.88,305.53 152.13,308.39C139.38,311.25 136.83,325.29 136.19,328.16C135.48,331.36 131.53,398.25 132.8,398.57C134.07,398.89 143.64,399.84 143.64,399.84C143.64,399.84 159.78,334.84 164.56,333.89C169.34,332.94 240.1,334.53 250.62,328.79C261.14,323.05 263.69,306.48 257.62,295.01C251.55,283.54 193.57,292.78 193.57,292.78Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.92,305.53C236.92,305.53 207.27,305.53 192.92,306.8C178.57,308.07 169.65,318.91 170.29,328.48C170.93,338.05 182.52,400.8 182.52,400.8L193.67,399.8L199.67,332.56C199.67,332.56 209.67,339.04 248.46,329.08",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.72,203.21C305.72,202.57 302.58,210.86 302.58,210.86C300.561,210.752 298.539,210.752 296.52,210.86C293.02,211.18 290.15,215.96 290.15,219.15C290.15,222.34 275.48,247.83 275.48,247.83C275.48,247.83 262.73,226.83 258.27,223.29C253.81,219.75 237.27,216.6 237.27,216.6C230.501,215.54 223.609,215.54 216.84,216.6C210.071,217.66 200.27,219.78 195.84,223.29C191.41,226.8 178.62,247.83 178.62,247.83C178.62,247.83 163.96,222.33 163.96,219.15C163.96,215.97 161.09,211.15 157.59,210.86C155.571,210.752 153.549,210.752 151.53,210.86C149.511,210.968 148.34,202.57 147.39,203.21C146.44,203.85 148.02,214.05 148.98,216.28C149.94,218.51 157.91,220.1 157.91,220.1C157.91,220.1 167.79,257.71 170.97,262.81C174.15,267.91 177.67,274.29 186.27,270.46C194.87,266.63 205.72,254.21 205.72,254.21L223.91,254.49L226.43,254.49L248.43,254.21C248.43,254.21 259.27,266.64 267.87,270.46C276.47,274.28 279.99,267.91 283.17,262.81C286.35,257.71 296.2,220.1 296.2,220.1C296.2,220.1 304.2,218.51 305.13,216.28C306.06,214.05 307.68,203.85 306.72,203.21Z",
    style: {
      fill: "rgb(156,156,156)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.64,238.66C277.83,243.76 275.48,247.83 275.48,247.83C275.48,247.83 262.73,226.83 258.27,223.29C253.81,219.75 237.27,216.6 237.27,216.6C230.501,215.54 223.609,215.54 216.84,216.6C210.071,217.66 200.27,219.78 195.84,223.29C191.41,226.8 178.62,247.83 178.62,247.83C178.62,247.83 176.08,243.42 173.12,238.03L164.35,243.37C166.91,252.16 169.58,260.59 170.97,262.81C174.16,267.91 177.67,274.29 186.27,270.46C194.87,266.63 205.72,254.21 205.72,254.21L223.91,254.49L226.43,254.49L248.43,254.21C248.43,254.21 259.27,266.64 267.87,270.46C276.47,274.28 279.99,267.91 283.17,262.81C284.57,260.58 287.25,252.12 289.82,243.3L280.64,238.66Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.64,238.66C277.83,243.76 275.48,247.83 275.48,247.83C275.48,247.83 262.73,226.83 258.27,223.29C253.81,219.75 237.27,216.6 237.27,216.6C230.501,215.54 223.609,215.54 216.84,216.6C210.071,217.66 200.27,219.78 195.84,223.29C191.41,226.8 178.62,247.83 178.62,247.83C178.62,247.83 176.08,243.42 173.12,238.03L164.35,243.37C166.91,252.16 169.58,260.59 170.97,262.81C174.16,267.91 177.67,274.29 186.27,270.46C194.87,266.63 205.72,254.21 205.72,254.21L223.91,254.49L226.43,254.49L248.43,254.21C248.43,254.21 259.27,266.64 267.87,270.46C276.47,274.28 279.99,267.91 283.17,262.81C284.57,260.58 287.25,252.12 289.82,243.3L280.64,238.66Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273,253.73C272.83,251.64 272.67,249.66 273.52,248.39C273.916,247.796 274.35,247.228 274.82,246.69L273.56,244.69C272.819,245.443 272.15,246.263 271.56,247.14C270.27,249.08 270.46,251.55 270.66,253.95C270.82,256.04 270.98,258.01 270.13,259.29C269.4,260.38 268.69,260.29 266.74,259.89C264.891,259.357 262.929,259.357 261.08,259.89C259.444,260.488 258.206,261.861 257.78,263.55C258.41,264.1 259.06,264.65 259.72,265.18C259.99,263.75 260.59,262.48 261.81,262.08C263.275,261.68 264.824,261.697 266.28,262.13C268.22,262.53 270.43,262.99 272.05,260.55C273.36,258.6 273.16,256.13 273,253.73Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.39,254.21L249.15,255.06C249.836,254.777 250.49,254.422 251.1,254C251.802,253.847 252.528,253.847 253.23,254C255.608,254.316 258.025,254.156 260.34,253.53C264.21,252.42 264.34,248.22 264.48,244.53C264.55,242.47 264.62,240.33 265.33,239.04C266.016,237.738 267.541,237.098 268.95,237.52C268.44,236.73 267.95,235.94 267.38,235.15C265.627,235.294 264.075,236.352 263.3,237.93C262.3,239.7 262.25,242.12 262.17,244.45C262.04,248.32 261.8,250.72 259.71,251.31C257.668,251.862 255.536,251.998 253.44,251.71C251.93,251.58 250.63,251.46 249.65,252.24C248.141,253.057 246.557,253.727 244.92,254.24L248.39,254.21Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.57,259.88C191.721,259.347 189.759,259.347 187.91,259.88C185.96,260.28 185.25,260.37 184.52,259.28C183.67,258 183.83,256.03 184,253.94C184.19,251.54 184.38,249.07 183.09,247.13C182.425,246.1 181.643,245.151 180.76,244.3L179.5,246.3C180.12,246.943 180.679,247.643 181.17,248.39C182.02,249.66 181.86,251.64 181.69,253.73C181.5,256.13 181.3,258.6 182.6,260.54C184.22,262.98 186.43,262.54 188.37,262.12C189.826,261.687 191.375,261.67 192.84,262.07C193.932,262.547 194.693,263.568 194.84,264.75C195.49,264.22 196.12,263.68 196.74,263.13C196.244,261.615 195.072,260.414 193.57,259.88Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.23,251.68C199.131,251.968 196.996,251.832 194.95,251.28C192.86,250.69 192.62,248.28 192.49,244.42C192.41,242.09 192.33,239.67 191.36,237.9C190.482,236.135 188.651,235.035 186.68,235.09C186.1,235.96 185.53,236.83 184.97,237.69C186.14,237.29 188.22,236.96 189.33,239.01C190.04,240.3 190.11,242.44 190.18,244.5C190.31,248.2 190.46,252.4 194.32,253.5C196.635,254.126 199.052,254.286 201.43,253.97C202.132,253.817 202.858,253.817 203.56,253.97C204.032,254.306 204.538,254.591 205.07,254.82L205.66,254.17L209.8,254.23C208.141,253.698 206.537,253.008 205.01,252.17C204,251.43 202.73,251.55 201.23,251.68Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273,253.73C272.83,251.64 272.67,249.66 273.52,248.39C273.916,247.796 274.35,247.228 274.82,246.69L273.56,244.69C272.819,245.443 272.15,246.263 271.56,247.14C270.27,249.08 270.46,251.55 270.66,253.95C270.82,256.04 270.98,258.01 270.13,259.29C269.4,260.38 268.69,260.29 266.74,259.89C264.891,259.357 262.929,259.357 261.08,259.89C259.444,260.488 258.206,261.861 257.78,263.55C258.41,264.1 259.06,264.65 259.72,265.18C259.99,263.75 260.59,262.48 261.81,262.08C263.275,261.68 264.824,261.697 266.28,262.13C268.22,262.53 270.43,262.99 272.05,260.55C273.36,258.6 273.16,256.13 273,253.73Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.39,254.21L249.15,255.06C249.836,254.777 250.49,254.422 251.1,254C251.802,253.847 252.528,253.847 253.23,254C255.608,254.316 258.025,254.156 260.34,253.53C264.21,252.42 264.34,248.22 264.48,244.53C264.55,242.47 264.62,240.33 265.33,239.04C266.016,237.738 267.541,237.098 268.95,237.52C268.44,236.73 267.95,235.94 267.38,235.15C265.627,235.294 264.075,236.352 263.3,237.93C262.3,239.7 262.25,242.12 262.17,244.45C262.04,248.32 261.8,250.72 259.71,251.31C257.668,251.862 255.536,251.998 253.44,251.71C251.93,251.58 250.63,251.46 249.65,252.24C248.141,253.057 246.557,253.727 244.92,254.24L248.39,254.21Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.57,259.88C191.721,259.347 189.759,259.347 187.91,259.88C185.96,260.28 185.25,260.37 184.52,259.28C183.67,258 183.83,256.03 184,253.94C184.19,251.54 184.38,249.07 183.09,247.13C182.425,246.1 181.643,245.151 180.76,244.3L179.5,246.3C180.12,246.943 180.679,247.643 181.17,248.39C182.02,249.66 181.86,251.64 181.69,253.73C181.5,256.13 181.3,258.6 182.6,260.54C184.22,262.98 186.43,262.54 188.37,262.12C189.826,261.687 191.375,261.67 192.84,262.07C193.932,262.547 194.693,263.568 194.84,264.75C195.49,264.22 196.12,263.68 196.74,263.13C196.244,261.615 195.072,260.414 193.57,259.88Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.23,251.68C199.131,251.968 196.996,251.832 194.95,251.28C192.86,250.69 192.62,248.28 192.49,244.42C192.41,242.09 192.33,239.67 191.36,237.9C190.482,236.135 188.651,235.035 186.68,235.09C186.1,235.96 185.53,236.83 184.97,237.69C186.14,237.29 188.22,236.96 189.33,239.01C190.04,240.3 190.11,242.44 190.18,244.5C190.31,248.2 190.46,252.4 194.32,253.5C196.635,254.126 199.052,254.286 201.43,253.97C202.132,253.817 202.858,253.817 203.56,253.97C204.032,254.306 204.538,254.591 205.07,254.82L205.66,254.17L209.8,254.23C208.141,253.698 206.537,253.008 205.01,252.17C204,251.43 202.73,251.55 201.23,251.68Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M280.64,238.66C277.83,243.76 275.48,247.83 275.48,247.83C275.48,247.83 262.73,226.83 258.27,223.29C253.81,219.75 237.27,216.6 237.27,216.6C230.501,215.54 223.609,215.54 216.84,216.6C210.071,217.66 200.27,219.78 195.84,223.29C191.41,226.8 178.62,247.83 178.62,247.83C178.62,247.83 176.08,243.42 173.12,238.03L164.35,243.37C166.91,252.16 169.58,260.59 170.97,262.81C174.16,267.91 177.67,274.29 186.27,270.46C194.87,266.63 205.72,254.21 205.72,254.21L223.91,254.49L226.43,254.49L248.43,254.21C248.43,254.21 259.27,266.64 267.87,270.46C276.47,274.28 279.99,267.91 283.17,262.81C284.57,260.58 287.25,252.12 289.82,243.3L280.64,238.66Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.62,238.91C199.62,238.91 195.48,247.83 196.44,253.57C196.892,255.883 197.21,258.22 197.39,260.57C197.57,262.92 191.39,277.15 190.39,283.2C189.505,288.323 191.611,293.525 195.81,296.59C199.32,299.14 247.13,299.78 254.46,297.87C261.79,295.96 261.15,288.94 260.83,282.57C260.51,276.2 258,262.5 258,262.5C258,262.5 259,243.05 254.82,238.27",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.62,238.91C199.62,238.91 195.48,247.83 196.44,253.57C196.892,255.883 197.21,258.22 197.39,260.57C197.57,262.92 191.39,277.15 190.39,283.2C189.505,288.323 191.611,293.525 195.81,296.59C199.32,299.14 247.13,299.78 254.46,297.87C261.79,295.96 261.15,288.94 260.83,282.57C260.51,276.2 258,262.5 258,262.5C258,262.5 259,243.05 254.82,238.27"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.21,251.72C234.512,251.64 232.909,250.905 231.74,249.67C227.39,245.67 224.49,245.01 221.41,247.25L220,248.33C216.81,250.77 213.79,253.07 209.07,250.16C207.99,249.5 207.01,248.79 206.15,248.16C202.98,245.86 201.6,245 199.33,246.86C197.64,248.24 196.33,249.06 194.83,248.86C192.92,248.63 191.58,246.86 188.92,243.3L188.74,243.06C187.96,241.83 186.681,241 185.24,240.79C183.727,240.819 182.279,241.419 181.19,242.47C180.974,242.687 180.681,242.809 180.375,242.809C180.069,242.809 179.776,242.687 179.56,242.47C179.341,242.256 179.217,241.962 179.217,241.655C179.217,241.348 179.341,241.054 179.56,240.84C181.12,239.318 183.22,238.473 185.4,238.49C187.517,238.721 189.423,239.889 190.59,241.67L190.76,241.91C192.82,244.65 194.17,246.46 195.11,246.57C195.64,246.63 196.48,246.18 197.87,245.05C201.6,241.99 204.47,244.05 207.51,246.27C208.38,246.9 209.28,247.55 210.28,248.17C213.65,250.25 215.51,248.83 218.6,246.48C219.07,246.11 219.6,245.74 220.08,245.37C225.2,241.64 229.65,244.58 233.33,247.95C236.08,250.47 237.82,249.36 241.47,246.61C242.17,246.09 242.9,245.53 243.69,244.99L244.05,244.74C248.76,241.47 249.28,241.74 255.65,245.27L257.36,246.21C259.57,247.43 260.93,248.21 261.56,248.14C262.19,248.07 262.65,247.45 263.86,246.08C264.35,245.51 264.94,244.85 265.66,244.08C270.82,238.55 272.51,238.92 276.66,240.81L276.99,240.96C277.402,241.146 277.667,241.558 277.667,242.01C277.667,242.642 277.147,243.162 276.515,243.162C276.351,243.162 276.189,243.128 276.04,243.06L275.71,242.91C272.27,241.34 271.65,241.06 267.35,245.66C266.66,246.41 266.09,247.05 265.6,247.61C262.28,251.38 261.6,251.18 256.25,248.23L254.55,247.29C248.91,244.19 248.91,244.19 245.38,246.64L245.01,246.89C244.25,247.42 243.55,247.95 242.87,248.46C240.64,250.12 238.53,251.72 236.21,251.72ZM242.83,259.56C243.51,259.05 244.21,258.51 244.97,257.99L245.34,257.74C248.87,255.28 248.87,255.29 254.51,258.39L256.21,259.33C261.54,262.28 262.21,262.48 265.56,258.71C266.05,258.15 266.62,257.5 267.31,256.76C271.61,252.15 272.23,252.44 275.67,254.01L276,254.16C276.149,254.228 276.311,254.262 276.475,254.262C277.107,254.262 277.627,253.742 277.627,253.11C277.627,252.658 277.362,252.246 276.95,252.06L276.62,251.91C272.49,250.02 270.79,249.65 265.62,255.18C264.9,255.95 264.31,256.61 263.82,257.18C262.61,258.55 262.01,259.18 261.52,259.24C261.03,259.3 259.52,258.53 257.32,257.31L255.61,256.37C249.24,252.86 248.72,252.57 244.01,255.84L243.65,256.09C242.86,256.63 242.13,257.18 241.43,257.71C237.78,260.46 236.04,261.57 233.29,259.05C229.61,255.68 225.16,252.73 220.04,256.46C219.52,256.84 219.04,257.21 218.56,257.58C215.47,259.93 213.61,261.35 210.24,259.27C209.24,258.65 208.34,258 207.47,257.37C204.47,255.17 201.56,253.09 197.83,256.15C196.44,257.28 195.63,257.74 195.07,257.67C194.13,257.56 192.78,255.75 190.72,253.01L190.55,252.77C189.383,250.989 187.477,249.821 185.36,249.59C183.18,249.573 181.08,250.418 179.52,251.94C179.301,252.154 179.177,252.448 179.177,252.755C179.177,253.062 179.301,253.356 179.52,253.57C179.736,253.787 180.029,253.909 180.335,253.909C180.641,253.909 180.934,253.787 181.15,253.57C182.239,252.519 183.687,251.919 185.2,251.89C186.645,252.09 187.928,252.922 188.7,254.16L188.88,254.4C191.54,257.95 192.88,259.73 194.79,259.96C196.25,260.14 197.6,259.32 199.29,257.96C201.56,256.11 202.94,256.96 206.11,259.27C206.97,259.9 207.95,260.61 209.03,261.27C213.75,264.18 216.77,261.88 219.96,259.44L221.4,258.36C224.48,256.12 227.4,256.8 231.73,260.78C232.906,261.998 234.508,262.715 236.2,262.78C238.53,262.79 240.64,261.2 242.83,259.56Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.21,251.72C234.512,251.64 232.909,250.905 231.74,249.67C227.39,245.67 224.49,245.01 221.41,247.25L220,248.33C216.81,250.77 213.79,253.07 209.07,250.16C207.99,249.5 207.01,248.79 206.15,248.16C202.98,245.86 201.6,245 199.33,246.86C197.64,248.24 196.33,249.06 194.83,248.86C192.92,248.63 191.58,246.86 188.92,243.3L188.74,243.06C187.96,241.83 186.681,241 185.24,240.79C183.727,240.819 182.279,241.419 181.19,242.47C180.974,242.687 180.681,242.809 180.375,242.809C180.069,242.809 179.776,242.687 179.56,242.47C179.341,242.256 179.217,241.962 179.217,241.655C179.217,241.348 179.341,241.054 179.56,240.84C181.12,239.318 183.22,238.473 185.4,238.49C187.517,238.721 189.423,239.889 190.59,241.67L190.76,241.91C192.82,244.65 194.17,246.46 195.11,246.57C195.64,246.63 196.48,246.18 197.87,245.05C201.6,241.99 204.47,244.05 207.51,246.27C208.38,246.9 209.28,247.55 210.28,248.17C213.65,250.25 215.51,248.83 218.6,246.48C219.07,246.11 219.6,245.74 220.08,245.37C225.2,241.64 229.65,244.58 233.33,247.95C236.08,250.47 237.82,249.36 241.47,246.61C242.17,246.09 242.9,245.53 243.69,244.99L244.05,244.74C248.76,241.47 249.28,241.74 255.65,245.27L257.36,246.21C259.57,247.43 260.93,248.21 261.56,248.14C262.19,248.07 262.65,247.45 263.86,246.08C264.35,245.51 264.94,244.85 265.66,244.08C270.82,238.55 272.51,238.92 276.66,240.81L276.99,240.96C277.402,241.146 277.667,241.558 277.667,242.01C277.667,242.642 277.147,243.162 276.515,243.162C276.351,243.162 276.189,243.128 276.04,243.06L275.71,242.91C272.27,241.34 271.65,241.06 267.35,245.66C266.66,246.41 266.09,247.05 265.6,247.61C262.28,251.38 261.6,251.18 256.25,248.23L254.55,247.29C248.91,244.19 248.91,244.19 245.38,246.64L245.01,246.89C244.25,247.42 243.55,247.95 242.87,248.46C240.64,250.12 238.53,251.72 236.21,251.72ZM242.83,259.56C243.51,259.05 244.21,258.51 244.97,257.99L245.34,257.74C248.87,255.28 248.87,255.29 254.51,258.39L256.21,259.33C261.54,262.28 262.21,262.48 265.56,258.71C266.05,258.15 266.62,257.5 267.31,256.76C271.61,252.15 272.23,252.44 275.67,254.01L276,254.16C276.149,254.228 276.311,254.262 276.475,254.262C277.107,254.262 277.627,253.742 277.627,253.11C277.627,252.658 277.362,252.246 276.95,252.06L276.62,251.91C272.49,250.02 270.79,249.65 265.62,255.18C264.9,255.95 264.31,256.61 263.82,257.18C262.61,258.55 262.01,259.18 261.52,259.24C261.03,259.3 259.52,258.53 257.32,257.31L255.61,256.37C249.24,252.86 248.72,252.57 244.01,255.84L243.65,256.09C242.86,256.63 242.13,257.18 241.43,257.71C237.78,260.46 236.04,261.57 233.29,259.05C229.61,255.68 225.16,252.73 220.04,256.46C219.52,256.84 219.04,257.21 218.56,257.58C215.47,259.93 213.61,261.35 210.24,259.27C209.24,258.65 208.34,258 207.47,257.37C204.47,255.17 201.56,253.09 197.83,256.15C196.44,257.28 195.63,257.74 195.07,257.67C194.13,257.56 192.78,255.75 190.72,253.01L190.55,252.77C189.383,250.989 187.477,249.821 185.36,249.59C183.18,249.573 181.08,250.418 179.52,251.94C179.301,252.154 179.177,252.448 179.177,252.755C179.177,253.062 179.301,253.356 179.52,253.57C179.736,253.787 180.029,253.909 180.335,253.909C180.641,253.909 180.934,253.787 181.15,253.57C182.239,252.519 183.687,251.919 185.2,251.89C186.645,252.09 187.928,252.922 188.7,254.16L188.88,254.4C191.54,257.95 192.88,259.73 194.79,259.96C196.25,260.14 197.6,259.32 199.29,257.96C201.56,256.11 202.94,256.96 206.11,259.27C206.97,259.9 207.95,260.61 209.03,261.27C213.75,264.18 216.77,261.88 219.96,259.44L221.4,258.36C224.48,256.12 227.4,256.8 231.73,260.78C232.906,261.998 234.508,262.715 236.2,262.78C238.53,262.79 240.64,261.2 242.83,259.56Z",
    style: {
      fill: "white",
      fillOpacity: 0.5,
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M199.62,238.91C199.62,238.91 195.48,247.83 196.44,253.57C196.892,255.883 197.21,258.22 197.39,260.57C197.57,262.92 191.39,277.15 190.39,283.2C189.505,288.323 191.611,293.525 195.81,296.59C199.32,299.14 247.13,299.78 254.46,297.87C261.79,295.96 261.15,288.94 260.83,282.57C260.51,276.2 258,262.5 258,262.5C258,262.5 259,243.05 254.82,238.27",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.81,216.6L215.45,216.87C215.32,217.461 215.249,218.064 215.24,218.67C215.24,224.74 221.74,229.67 229.75,229.67C237.76,229.67 244.25,224.74 244.25,218.67L244.25,218.15C240.38,217.15 237.25,216.6 237.25,216.6C230.478,215.539 223.582,215.539 216.81,216.6Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,210.54C220,210.54 219,218.19 220,220.74C221,223.29 227,228.07 233.07,226.16C237.123,224.888 239.942,221.166 240.07,216.92L240.07,208L220.31,208.64L220,210.54Z",
    style: {
      fill: "rgb(156,156,156)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 230.22,
    cy: 185.2,
    rx: 22.63,
    ry: 22.15,
    style: {
      fill: "rgb(38,50,56)",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.88,192.69C215.88,192.69 213.97,188.23 212.69,192.37C211.41,196.51 214.29,201.62 216.2,201.93C218.11,202.24 215.88,192.69 215.88,192.69Z",
    style: {
      fill: "rgb(156,156,156)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.43,192.69C243.43,192.69 245.34,188.23 246.62,192.37C247.9,196.51 245.02,201.62 243.11,201.93C241.2,202.24 243.43,192.69 243.43,192.69Z",
    style: {
      fill: "rgb(156,156,156)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.64,177.8C237.912,176.484 235.709,175.951 233.57,176.33C231.628,176.71 229.646,176.851 227.67,176.75C224.49,176.44 221.94,175.16 219.39,177.75C216.84,180.34 215.56,192.09 215.56,198.15C215.56,204.21 220,212.77 223.21,215C226.42,217.23 235.32,216.92 237.55,215C239.78,213.08 243.29,206.08 243.93,200.34C244.57,194.6 243.29,183.45 242.02,180.58C241.458,179.478 240.643,178.525 239.64,177.8Z",
    style: {
      fill: "rgb(156,156,156)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.46,
    cy: 191.69,
    rx: 1.19,
    ry: 1.95,
    style: {
      fill: "rgb(38,50,56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.05,191.69C236.05,192.77 235.52,193.64 234.86,193.64C234.2,193.64 233.67,192.77 233.67,191.69C233.67,190.61 234.21,189.74 234.86,189.74C235.51,189.74 236.05,190.62 236.05,191.69Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.62,202.72C231.62,203.79 231.09,204.66 230.43,204.66C229.77,204.66 229.24,203.79 229.24,202.72C229.24,201.65 229.77,200.77 230.43,200.77C231.09,200.77 231.62,201.64 231.62,202.72Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.05,194.07C226.05,197.2 229.85,199.21 232.38,197.31C234.11,196.01 232.38,194.07 232.38,194.07",
    style: {
      fill: "rgb(156,156,156)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.35,187.37C221.35,187.37 224.59,184.37 227.84,185.85",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.24,186.07C233.24,186.07 236.24,184.12 239.08,187.8",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.8,398.57C132.8,398.57 113.65,402.32 113.65,404.27C113.65,406.22 138.05,411.76 140.65,412.08C143.25,412.4 143.65,399.84 143.65,399.84L132.8,398.57Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.25,410.21L114.93,403.21C114.13,403.58 113.65,403.94 113.65,404.21C113.65,406.21 138.05,411.7 140.65,412.02C141.32,412.16 141.84,411.39 142.25,410.21Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.53,400.8C182.53,400.8 163.1,409.15 164.4,411.11C165.7,413.07 191.08,412.11 193.68,411.76C196.28,411.41 193.68,399.84 193.68,399.84L182.53,400.8Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,409.88C164.43,410.39 164.17,410.82 164.36,411.11C165.66,413.06 191.04,412.11 193.64,411.76C194.27,411.68 194.59,410.94 194.72,409.88L165,409.88Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,-7.65714e-16,7.65714e-16,-1,279.48,542.46)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.07,
    y: 269.75,
    width: 73.33,
    height: 2.96,
    style: {
      fill: "white",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,-7.65714e-16,7.65714e-16,-1,238.13,542.46)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.4,
    y: 269.75,
    width: 73.33,
    height: 2.96,
    style: {
      fill: "white",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90.57,264.49L151.72,264.49L145.13,217.81L83.98,217.81L90.57,264.49Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.04,264.49L149.19,264.49L142.6,217.81L81.45,217.81L88.04,264.49Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.78,242.79L100.64,272.71L116.42,272.71L122.56,242.79L106.78,242.79ZM117.48,251.67C117.42,251.92 117.197,252.098 116.94,252.1L108,252C107.695,251.997 107.445,251.745 107.445,251.44C107.445,251.396 107.45,251.353 107.46,251.31L108.27,247.96C108.33,247.707 108.56,247.528 108.82,247.53L117.76,247.62C118.06,247.622 118.306,247.87 118.306,248.17C118.306,248.214 118.3,248.257 118.29,248.3L117.48,251.67Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.22971,-0.973259,0.973259,0.22971,-144.91,245.81)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 82.85,
    cy: 214.46,
    r: 11.26,
    style: {
      fill: "rgb(15,152,247)",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.69,216.74L79.37,220.52C79.225,220.711 79.049,220.876 78.85,221.01C78.388,221.361 77.779,221.459 77.23,221.27C76.806,221.144 76.464,220.825 76.31,220.41C76.082,219.721 76.282,218.958 76.82,218.47L80.67,214.39L77,210.13C76.719,209.792 76.557,209.37 76.54,208.93C76.509,208.564 76.633,208.201 76.88,207.93C77.119,207.681 77.414,207.492 77.74,207.38C78.099,207.251 78.491,207.251 78.85,207.38C79.281,207.544 79.656,207.829 79.93,208.2L83.12,212L86.12,208.51C86.275,208.289 86.464,208.093 86.68,207.93C87.139,207.501 87.807,207.376 88.39,207.61C88.805,207.76 89.136,208.081 89.3,208.49C89.518,208.965 89.427,209.528 89.07,209.91L85.07,214.28L89.07,218.97C89.197,219.128 89.301,219.303 89.38,219.49C89.577,219.984 89.48,220.549 89.13,220.95C88.82,221.345 88.351,221.583 87.85,221.6C87.102,221.614 86.399,221.234 86,220.6L82.69,216.74Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,289.73L223.82,409.44C223.782,411.015 222.476,412.29 220.9,412.29C219.319,412.274 218.022,410.981 218,409.4L216.44,289.73L227,289.73Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.34,289.73L185.17,409.44C185.132,411.019 183.82,412.296 182.24,412.29C180.649,412.29 179.336,410.991 179.32,409.4L177.75,289.73L188.34,289.73Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.72,289.73L89.55,409.44C89.512,411.019 88.2,412.296 86.62,412.29C85.029,412.29 83.716,410.991 83.7,409.4L82.13,289.73L92.72,289.73Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,289.73L50.87,409.44C50.833,410.997 49.557,412.264 48,412.29C47.977,412.291 47.953,412.291 47.93,412.291C46.337,412.291 45.021,410.992 45,409.4L43.46,289.73L54,289.73Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,-7.65714e-16,7.65714e-16,-1,270.71,567.64)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.93,
    y: 276.65,
    width: 190.85,
    height: 14.33,
    style: {
      fill: "white",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,-7.65714e-16,7.65714e-16,-1,408.25,567.64)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 177.47,
    y: 276.65,
    width: 53.31,
    height: 14.33,
    style: {
      fill: "white",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,-7.65714e-16,7.65714e-16,-1,270.71,560.47)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.93,
    y: 276.65,
    width: 190.85,
    height: 7.16,
    style: {
      fill: "rgb(38,50,56)",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,-7.65714e-16,7.65714e-16,-1,270.71,551.34)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.97,
    y: 271.72,
    width: 196.77,
    height: 7.89,
    style: {
      fill: "rgb(15,152,247)",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,-7.65714e-16,7.65714e-16,-1,210.9,551.34)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.97,
    y: 271.72,
    width: 136.96,
    height: 7.89,
    style: {
      fill: "rgb(15,152,247)",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M466.77,412.29L475,412.29",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,412.29L453.38,412.29",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: "1.23px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-46"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-46"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-46"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-46"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.a9915ddac569739d68a0aff662bbbbba.svg";
export { ForwardRef as ReactComponent };